<div class="header">
    <ng-content [select]="first"></ng-content>
    <ng-content [select]="second"></ng-content>
    <ng-content [select]="third"></ng-content>
</div>